module.exports = __webpack_public_path__ + "img/london-britches.c3ce0efa.png";